var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6193 4.72024C46.3682 4.72024 37.9908 -1.18553 31.6851 1.42928C25.1483 4.13998 23.4304 14.3391 18.5041 19.2654C13.5781 24.1913 3.37866 25.9096 0.66796 32.4464C-1.94685 38.7521 3.95892 47.1295 3.95892 54.3807C3.95892 61.6319 -1.94647 70.0092 0.66796 76.3149C3.37866 82.8518 13.5778 84.5696 18.5041 89.4959C23.43 94.4219 25.1483 104.621 31.6851 107.332C37.9908 109.947 46.3682 104.041 53.6193 104.041L78.3143 48.1701L53.6193 4.72024Z",
    fill: "#00D08B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6191 4.72024V104.041C60.8703 104.041 69.2477 109.947 75.5534 107.332C82.0902 104.621 83.8081 94.4219 88.7344 89.4959C93.6603 84.57 103.86 82.8518 106.571 76.3149C109.185 70.0092 103.28 61.6319 103.28 54.3807C103.28 47.1295 109.185 38.7521 106.571 32.4464C103.86 25.9096 93.6607 24.1917 88.7344 19.2654C83.8085 14.3395 82.0902 4.13998 75.5534 1.42928C69.2477 -1.18553 60.8703 4.72024 53.6191 4.72024Z",
    fill: "#00B479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3165 54.3807L53.6215 92.9045C32.3455 92.9045 15.0977 75.6567 15.0977 54.3807C15.0977 33.1046 32.3455 15.8568 53.6215 15.8568L78.3165 54.3807Z",
    fill: "#00EC9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.145 54.3807C92.145 75.6567 74.8971 92.9045 53.6211 92.9045V15.8568C74.8971 15.8568 92.145 33.1046 92.145 54.3807Z",
    fill: "#00D08B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6179 55.3151L48.3581 61.9539L35.7264 48.1701L27.5312 55.6799L48.9723 79.0779L53.6179 73.2142L58.4296 60.2948L53.6179 55.3151Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6191 73.2142L80.409 39.4012L71.6967 32.4984L53.6191 55.3151V73.2142Z",
    fill: "#E9E9EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6b99090cd62c3c50082207a6658b87fe.svg";
export { ForwardRef as ReactComponent };